module.exports = __webpack_public_path__ + "img/base_activites_pieds_nus.6f508a54.svg";